import ApiService from '../services/apiService';

export default ({ dispatch, params, callback, successCallback }) =>
  ApiService.request('get', '/public/sii_taxes', { dispatch, params, callback, successCallback });
